/* VST DIALOG JS */
async function vst_runPopup() {
  const local_old = "vst_canada20250925";
  const local_new = "vst_usa";
  const matchCountry = 'United States';
  // const matchCountry = 'Canada';
  const needMatch = true;
  let isMatch = false;
  const monthPast = 3;
  async function catchError(promise) {
    return promise
      .then(data => { return [undefined, data]; })
      .catch(error => { return [error]; });
  }
  async function getBrowserContext() {
    const [error, data] = await catchError(fetch(
      window.Shopify.routes.root
      + 'browsing_context_suggestions.json'
      + '?country[enabled]=true'
    ));
    if (error) { console.log("There was an error: ", error.message); }
    else { return data.json(); }
  }
  function isDate(value) {
    return value instanceof Date && !isNaN(value);
  }
  function dateMonthsPast(date, months) {
    const today = new Date();
    const monthsPast = new Date();
    monthsPast.setMonth(today.getMonth() - months);
    return date < monthsPast;
  }
  const browserContext = await getBrowserContext();
  if (needMatch) {
    isMatch = (browserContext.detected_values.country_name === matchCountry) ? true : false;
  } else {
    isMatch = true;
  }
  const dialog = document.querySelector('dialog.vst-dialog-notice');
  const btnAccept = dialog.querySelector('.button.accept');
  const btnSkip = dialog.querySelector('.button.skip');
  let dialogAccepted = false;

  vst_fireEvent('VST:CNA', 'Init', 'Dialog Initializing', {
    cna: dialogAccepted,
    isMatch: isMatch,
  });
  if (localStorage.getItem(local_old) !== null) { localStorage.removeItem(local_old); }
  if (localStorage.getItem(local_new) !== null) {
    const cnaDate = new Date(localStorage.getItem(local_new));
    if (isDate(cnaDate) && !dateMonthsPast(cnaDate, monthPast)) {
      dialogAccepted = true;
      vst_fireEvent('VST:CNA', 'Valid', 'Popup Accept Date Valid', dialogAccepted);
    } else {
      localStorage.removeItem(local_new);
      vst_fireEvent('VST:CNA', 'Expired', 'Popup Accept Date Expired', dialogAccepted);
    }
    vst_fireEvent('VST:CNA', 'Found', 'CNA Found', dialogAccepted);
  }
  btnAccept.addEventListener('pointerup', (e) => {
    if (e.button === 0) {
      e.preventDefault();
      localStorage.setItem(local_new, new Date().toISOString());
      dialog.close();
      vst_fireEvent('VST:CNA', 'Accepted', 'Dialog Accepted', true);
    }
  });
  btnSkip.addEventListener('pointerup', (e) => {
    if (e.button === 0) {
      e.preventDefault();
      dialog.close();
      vst_fireEvent('VST:CNA', 'Dismissed', 'Dialog Dismissed', false);
    }
  });
  vst_fireEvent('VST:CNA', 'Complete', 'Dialog Initalized', {
    cna: dialogAccepted,
    isMatch: isMatch,
  });

  if (isMatch && !dialogAccepted) {
    window.onload = () => {
      dialog.showModal();
      vst_fireEvent('VST:CNA', 'Showing', 'Dialog Showing', {
        cna: dialogAccepted,
        isMatch: isMatch,
      });
    };
  }
  return;
}
// Init Dialog
vst_runPopup();
